import { Injectable } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class FormsHelperService {
  constructor() {}

  static markDirtyTouched(control: AbstractControl) {
    switch (control.constructor.name) {
      case "FormGroup":
        this.markGroupDirty(control as FormGroup);
        break;
      case "FormArray":
        this.markArrayDirty(control as FormArray);
        break;
      case "FormControl":
        this.markControlDirty(control as FormControl);
        break;
    }
  }

  static markGroupDirty(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      switch (formGroup.get(key).constructor.name) {
        case "FormGroup":
          this.markGroupDirty(formGroup.get(key) as FormGroup);
          break;
        case "FormArray":
          this.markArrayDirty(formGroup.get(key) as FormArray);
          break;
        case "FormControl":
          this.markControlDirty(formGroup.get(key) as FormControl);
          break;
      }
    });
  }
  static markArrayDirty(formArray: FormArray) {
    formArray.controls.forEach((control) => {
      switch (control.constructor.name) {
        case "FormGroup":
          this.markGroupDirty(control as FormGroup);
          break;
        case "FormArray":
          this.markArrayDirty(control as FormArray);
          break;
        case "FormControl":
          this.markControlDirty(control as FormControl);
          break;
      }
    });
  }
  static markControlDirty(formControl: FormControl) {
    formControl.markAsDirty();
    formControl.markAsTouched();
  }

  static clearFormArray(formArray: FormArray, emitEvent = true) {
    while (formArray.length !== 0) {
      formArray.removeAt(0, { emitEvent: emitEvent });
    }
  }

  static isAbstractControl(v: unknown): v is AbstractControl {
    return (
      v instanceof AbstractControl ||
      (v != null &&
        typeof v === "object" &&
        "invalid" in v &&
        "updateValueAndValidity" in v)
    );
  }
}
